/* ============================================================
   DASH PLANNER — Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Header scroll effect ──────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ── Mobile menu ───────────────────────────────────────────
  const menuBtn = document.querySelector('.header-mobile-menu');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');

  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ── Cart Drawer ───────────────────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = cartDrawer?.querySelector('.cart-drawer__overlay');
  const cartClose = cartDrawer?.querySelector('.cart-drawer__close');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);

  // Cart icon opens drawer
  document.querySelectorAll('[data-cart-trigger]').forEach(el => {
    el.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  });

  // ── Cart API helpers ──────────────────────────────────────
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    if (!res.ok) throw new Error('Could not add to cart');
    return res.json();
  }

  async function removeFromCart(lineKey) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    return res.json();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── Render cart drawer ────────────────────────────────────
  async function refreshCartDrawer() {
    const content = document.getElementById('cart-drawer-content');
    const footer = document.getElementById('cart-drawer-footer');
    const totalEl = document.getElementById('cart-drawer-total');
    if (!content) return;

    const cart = await getCart();

    if (cart.item_count === 0) {
      content.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="btn btn--primary">Shop Now</a>
        </div>`;
      if (footer) footer.style.display = 'none';
    } else {
      content.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <img class="cart-item__image" src="${item.image}" alt="${item.title}" width="80" height="80">
          <div class="cart-item__info">
            <div class="cart-item__title">${item.product_title}</div>
            <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
            <button class="cart-item__remove" data-key="${item.key}">Remove</button>
          </div>
        </div>`).join('');

      if (footer) footer.style.display = 'block';
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      content.querySelectorAll('[data-key]').forEach(btn => {
        btn.addEventListener('click', async () => {
          await removeFromCart(btn.dataset.key);
          refreshCartDrawer();
          updateCartCount();
        });
      });
    }

    updateCartCount();
  }

  // ── Cart count badge ──────────────────────────────────────
  async function updateCartCount() {
    const cart = await getCart();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }

  updateCartCount();

  // ── Add to Cart form ──────────────────────────────────────
  const addToCartForm = document.getElementById('product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = addToCartForm.querySelector('[type="submit"]');
      const variantId = addToCartForm.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        await addToCart(parseInt(variantId));
        showNotification();
        updateCartCount();
        setTimeout(() => openCart(), 400);
      } catch {
        btn.textContent = 'Error — Try Again';
      } finally {
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 2000);
      }
    });
  }

  // ── Quick add (collection page) ───────────────────────────
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.quickAdd;
      if (!variantId) return;
      btn.textContent = 'Adding…';
      try {
        await addToCart(parseInt(variantId));
        showNotification();
        updateCartCount();
        setTimeout(() => openCart(), 400);
      } catch {}
      setTimeout(() => { btn.textContent = 'Add to Cart'; }, 2000);
    });
  });

  // ── Cart notification toast ───────────────────────────────
  function showNotification() {
    const note = document.getElementById('cart-notification');
    if (!note) return;
    note.style.display = 'flex';
    setTimeout(() => { note.style.display = 'none'; }, 3000);
  }

  // ── Product gallery ───────────────────────────────────────
  const mainImage = document.getElementById('product-main-image');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (mainImage && thumbs.length) {
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        const src = thumb.querySelector('img')?.src;
        if (src) {
          mainImage.src = src;
          mainImage.alt = thumb.querySelector('img')?.alt || '';
        }
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  }

  // ── Product tabs ──────────────────────────────────────────
  const tabBtns = document.querySelectorAll('.product-tab-btn');
  const tabPanels = document.querySelectorAll('.product-tab-panel');

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(`tab-${target}`)?.classList.add('active');
    });
  });

  // ── Collection filters ────────────────────────────────────
  const filterTags = document.querySelectorAll('.filter-tag[data-url]');
  filterTags.forEach(tag => {
    tag.addEventListener('click', () => {
      window.location.href = tag.dataset.url;
    });
  });

  // ── Sort select ───────────────────────────────────────────
  const sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ── Newsletter form ───────────────────────────────────────
  const newsletterForms = document.querySelectorAll('.newsletter-form');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      // Shopify handles this natively via action URL — let it submit
    });
  });

});
